// extracted by mini-css-extract-plugin
export default {"container":"Side_container__MCyPO","menus":"Side_menus__Pno+L","mainBtn":"Side_mainBtn__M+ljB"};